import { Events } from "@Context/common/general/context";
import { useEffect, useState } from "react";

export const useExclusiveMode = () => {
  const [isExclusiveMode, setIsExclusiveMode] = useState(false);

  useEffect(() => {
    const handleExclusiveModeEntered = () => {
      setIsExclusiveMode(true);
    };

    const handleExclusiveModeExited = () => {
      setIsExclusiveMode(false);
    };

    Events.app.exclusivePageEntered.uniq(handleExclusiveModeEntered);
    Events.app.exclusivePageExited.uniq(handleExclusiveModeExited);

    return () => {
      Events.app.exclusivePageEntered.remove(handleExclusiveModeEntered);
      Events.app.exclusivePageExited.remove(handleExclusiveModeExited);
    };
  }, []);

  return isExclusiveMode;
};
